export default "__VITE_ASSET__d470a963__"